export const SELECT_LANGUAGE_ANALYTICS_ATTRIBUTES = {
    'data-aa-location': 'footer',
    'data-aa-category': 'action',
    'data-aa-action': 'Change language'
};
export const OPEN_LANGUAGE_ANALYTICS_ATTRIBUTES = {
    'data-aa-location': 'footer',
    'data-aa-category': 'interaction',
    'data-aa-action': 'Open language selector'
};
